// extracted by mini-css-extract-plugin
export default {"Wrap":"ContentBody_Wrap__EYDte","FadeUp":"ContentBody_FadeUp__UTy5a","NoTop":"ContentBody_NoTop__NAGHP"};